import React, {useEffect} from "react"
import {observer} from "mobx-react-lite"
import {UseStores} from "../../hooks/UseStores"
import SingleTable from "../../components/SingleTable"
import queryString from "query-string"
import {URLPATHS} from "../../utils/utils"
import {POI_DETAILS} from "../../gql/gqlPois"
import {Spinner} from "../../components/Spinner/index"
import InternalError from "../../components/InternalError"
import {useManualQuery} from "graphql-hooks"
import LowHeader from "./LowHeaderContainer"
import "./index.scss"

const PoiTable = () => {
  const {navStore, poiStore, gtMapStore, disStore} = UseStores()

  let table

  const emptyDivStyle = {
    backgroundColor: "#F3F3F3",
    height: "35px",
    width: "100%",
  }

  const parentHeightStyle = {height: "auto"}
  const childHeightStyle = {
    height: "inherit",
    overflow: "hidden",
  }

  const columns = [
    {
      name: "Business Name",
      key: "name",
      sortable: false,
      width: "30%",
      headClass: "poi-name",
      class: "poi-name",
    },
    {
      name: "Address",
      key: "address",
      sortable: false,
      width: "50%",
      headClass: "poi-address",
      class: "poi-address",
    },
    {
      name: "Status",
      key: "status",
      sortable: false,
      width: "20%",
      headClass: "status",
      class: "status",
    },
  ]

  const {id} = queryString.parse(window.location.search)

  let poiId = poiStore.poiId
  const [getPoiDetails, {data, loading, error}] = useManualQuery(POI_DETAILS, {
    variables: {poiId},
  })

  useEffect(() => {
    if (gtMapStore.mapObj.showLoader === true) {
      gtMapStore.setMapObj({showLoader: false})
    }
  }, [gtMapStore.mapObj.showLoader])

  useEffect(() => {
    if (poiStore.poiId === null) {
      let storedPoi = JSON.parse(localStorage.getItem("poi"))

      //The id from the url needs to match the id of the poi stored.
      //If the user edits the id in the URL, the stored POI cannot be shown.

      if (storedPoi && storedPoi.id === Number(id)) {
        poiStore.pushPoiObj(storedPoi)
        poiStore.setBusinessName(storedPoi.name)
        poiStore.setPoiId(storedPoi.id)

        //This is a hack to render the POI map in case user refreshes the page.
        // Currently the map doesn't render correctly if we directly pass the POI parameters.

        gtMapStore.setMapObj({
          geo: {geoType: "COUNTRY", geoId: 0},
          categoryId: disStore.sicCode,
          brandId: disStore.brandId,
          visitDuration: disStore.timePeriod,
          mapGeos: {STATE: null, DMA: null},
          showLoader: true,
          mapPadding: {left: 0},
        })
      } else {
        poiStore.setPoiId(Number(id))
      }
    }
    navStore.setCurrentPage(URLPATHS.POI)
  }, [])

  useEffect(() => {
    if (poiId === Number(id) && poiId !== null) {
      if (
        (poiStore.poiData.length !== 0 && poiStore.poiData[0].id !== poiId) ||
        poiStore.poiData.length === 0
      ) {
        getPoiDetails()
      }
    }
  }, [poiId])

  if (
    poiId === Number(id) &&
    poiStore.poiData.length !== 0 &&
    poiId === poiStore.poiData[0].id
  ) {
    table = (
      <div>
        <LowHeader businessName={poiStore.businessName} />
        <div style={emptyDivStyle}></div>
        <div className="brandsPage" style={parentHeightStyle}>
          <div className="brandsLeft" style={childHeightStyle}>
            <div className="brand-location-container">
              <div data-testid="poi-table">
                <SingleTable
                  data={poiStore.poiData}
                  columns={columns}
                  pagination={false}
                  selectableRows={false}
                />{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    )

    setTimeout(() => {
      gtMapStore.mapObj.geo.geoId !== poiStore.poiData[0].id &&
        gtMapStore.setMapObj({
          geo: {
            geoType: "POI",
            geoId: poiStore.poiData[0].id,
            lat: poiStore.poiData[0].latitude,
            lon: poiStore.poiData[0].longitude,
          },
          categoryId: null,
          brandId: null,
          locationGroupId: null,
          mapGeos: {STATE: null, DMA: null},
          showLoader: false,
          mapPadding: {left: 0},
        })
    }, 1000)
    return table
  } else {
    table = (
      <div className="no-locations-wrapper">
        {" "}
        <div className="no-locations" data-testid="no-locations">
          No Brand Locations Exist.{" "}
        </div>
      </div>
    )
  }

  if (loading) {
    table = (
      <div>
        <LowHeader businessName={poiStore.name} />
        <div style={emptyDivStyle}></div>
        <div className="brandsPage" style={{height: "80px"}}>
          <div className="brandsLeft">
            <div className="brand-location-container">
              <div data-testid="poi-table" className="poi-loader">
                <SingleTable
                  data={[]}
                  columns={columns}
                  pagination={false}
                  selectableRows={false}
                />
                <Spinner size="small" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
    return table
  }
  if (error) {
    table = <InternalError />
  }
  if (!error && data) {
    if (data.getPoiDetails && Object.keys(data.getPoiDetails).length !== 0) {
      if (
        (!poiStore.poiData.length || poiStore.poiData[0].id !== poiId) &&
        data.getPoiDetails.id === poiId
      ) {
        poiStore.setBusinessName(data.getPoiDetails.name)
        poiStore.setPoiData(data.getPoiDetails)
        gtMapStore.setMapObj({
          geo: {
            geoType: "POI",
            geoId: data.getPoiDetails.id,
            lat: data.getPoiDetails.latitude,
            lon: data.getPoiDetails.longitude,
          },
          categoryId: null,
          brandId: null,
          locationGroupId: null,
          mapGeos: {STATE: null, DMA: null},
          showLoader: false,
          mapPadding: {left: 0},
        })
      }
    } else {
      table = (
        <div data-testid="no-locations" className="no-locations-wrapper">
          {" "}
          <div className="no-locations">No Brand Locations Exist. </div>
        </div>
      )
    }
  }
  return (
    <div>
      <LowHeader businessName={poiStore.name} />
      <div style={emptyDivStyle}></div>
      <div className="brandsPage">
        <div className="brandsLeft">
          <div className="brand-location-container">{table}</div>
        </div>
      </div>
    </div>
  )
}
export default observer(PoiTable)
